import React, { useEffect, useState } from "react";
import secureLocalStorage from "react-secure-storage";
import { Col, Row, Menu, Modal, notification, Dropdown, Space } from "antd";
import {
  UnorderedListOutlined,
  UserOutlined,
  LogoutOutlined,
  ProfileOutlined,
  DownOutlined,
} from "@ant-design/icons";
import hostURL from "../../Common/constants";
import logo from "../../images/header/HORIZONTAL_web_white.png";
import "./style.css";
import { useNavigate } from "react-router-dom";

function Header({ noNavigation }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [toShowSpinner, setToShowSpinner] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();
  const isLoggedIn = secureLocalStorage.getItem("token");

  const openNotificationWithIcon = (type, title, message) => {
    api[type]({
      message: title,
      description: message,
    });
  };

  const activeMenu = window.location.pathname.substring(1);

  const handleNavigate = (path) => {
if (window.location.pathname === path) {
      navigate(0);  // Reloads the page
    } else {
      navigate(path);  // Navigate to the same route if not already there
    }
  };

  const showLogoutModal = () => setIsLogoutModalOpen(true);

  const handleLogoutOk = () => Signout();

  const handleLogoutCancel = () => setIsLogoutModalOpen(false);

  const showModal = () => setIsModalOpen(true);

  const handleCancel = () => setIsModalOpen(false);

  const selectedMenuItem = (itemData) => setSelectedItem(itemData.selectedKeys);

  const items = [
    {
      label: <span onClick={() => handleNavigate("/")}>Home</span>,
      key: "home",
      style: { fontWeight: "bold" },
      className: activeMenu === "" ? "activeMenu" : "",
    },
    {
      label: <span onClick={() => handleNavigate("/CRPMenu")}>About</span>,
      key: "crpMenu",
      style: { fontWeight: "bold" },
      className: activeMenu === "CRPMenu" ? "activeMenu" : "",
    },
    {
      label: (
        <span onClick={() => handleNavigate("/CRPBasics")}>CRP Basics</span>
      ),
      key: "crpBasics",
      style: { fontWeight: "bold" },
      className: activeMenu === "CRPBasics" ? "activeMenu" : "crp-basics",
    },
    {
      label: (
        <span onClick={() => handleNavigate("/PracticeList")}>
          Explore Practices
        </span>
      ),
      key: "explorePractices",
      style: { fontWeight: "bold" },
      className:
        activeMenu === "PracticeList" ? "activeMenu" : "explore-practices",
    },
    {
      label: (
        <span onClick={() => handleNavigate("/Map")}>Check Eligibility</span>
      ),
      key: "checkEligibility",
      style: { fontWeight: "bold" },
      className: activeMenu === "Map" ? "activeMenu" : "",
    },
    {
      label: (
        <span onClick={() => handleNavigate("/Workshops")}>Workshops</span>
      ),
      key: "workshops",
      style: { fontWeight: "bold" },
      className: activeMenu === "Workshops" ? "activeMenu" : "",
    },
    {
      label: <span onClick={() => handleNavigate("/ProjectTeam")}>Team</span>,
      key: "projectTeam",
      style: { fontWeight: "bold" },
      className: activeMenu === "ProjectTeam" ? "activeMenu" : "",
    },
    {
      label: <span onClick={() => handleNavigate("/Contact")}>Contact Us</span>,
      key: "contact",
      style: { fontWeight: "bold" },
      className: activeMenu === "Contact" ? "activeMenu" : "",
    },
  ];

  const userMenuItems = [
    {
      label: (
        <span onClick={() => handleNavigate("/UserProfile")}>
          <ProfileOutlined /> Profile
        </span>
      ),
      key: "uhome",
      style: { fontWeight: "bold" },
    },
    {
      label: (
        <span onClick={showLogoutModal}>
          <LogoutOutlined /> Logout
        </span>
      ),
      key: "ucrpMenu",
      style: { fontWeight: "bold" },
    },
  ];

  const Signout = async () => {
    setToShowSpinner(true);
    await fetch(hostURL + "api/users/signOut", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) =>
        response.json().then((json) => ({
          status: response.status,
          ok: response.ok,
          json,
        }))
      )
      .then(({ status, json }) => {
        setToShowSpinner(false);
        if (status === 200) {
          openNotificationWithIcon("success", "Success", json.message);
          secureLocalStorage.clear();
          sessionStorage.clear();
          setIsLogoutModalOpen(false);
          navigate("/");
        } else openNotificationWithIcon("error", "Error", json.message);
      });
  };

  return (
    <>
      <div className="msu_header">
        <Row>
          <Col xs={{ span: 24 }} lg={{ span: 16, offset: 1 }}>
            <Row>
              <span onClick={() => handleNavigate("/")}>
                <h1 className="header-tool-name">CRP Menu Tool</h1>
              </span>
            </Row>
          </Col>
          <Col
            className="gri-logo"
            xs={{ span: 24 }}
            lg={{ span: 4, offset: 2 }}
          >
            <a
              href="https://www.gri.msstate.edu/"
              rel="noreferrer"
              target="_blank"
            >
              <img className="header-logo" src={`${logo}`} alt="MSU Logo" />
            </a>
          </Col>
        </Row>
      </div>
      {noNavigation !== "print" && (
        <Row className="header-nav">
          <Col xs={{ span: 24 }} lg={{ span: 21, offset: 1 }}>
            <button
              className={
                isLoggedIn ? "crpMobileNavIcon loggedIn" : "crpMobileNavIcon"
              }
              onClick={showModal}
            >
              <UnorderedListOutlined />
            </button>
            <Menu
              className="crpmainnav"
              mode="horizontal centered"
              items={items}
              onSelect={selectedMenuItem}
              defaultSelectedKeys={items[0]}
              selectedKeys={[selectedItem]}
            />
            {(isLoggedIn === null || isLoggedIn.length === 0) &&
              noNavigation !== "print" && (
                <h6 className="register-login-link">
                  <span onClick={() => handleNavigate("/UserLogin")}>
                    <UserOutlined /> Register / Login
                  </span>
                </h6>
              )}
            <Modal
              title="Menu"
              open={isModalOpen}
              onCancel={handleCancel}
              footer={null}
            >
              <Menu mode="inline" items={items} />
            </Modal>
            {isLoggedIn !== null && isLoggedIn.length > 24 && (
              <Dropdown.Button
                className="loggedInMenu"
                icon={<DownOutlined />}
                menu={{ items: userMenuItems }}
              >
                <UserOutlined />
              </Dropdown.Button>
            )}
          </Col>
        </Row>
      )}
      <Modal
        title="Logout Confirmation"
        open={isLogoutModalOpen}
        onOk={handleLogoutOk}
        onCancel={handleLogoutCancel}
        okText="Ok"
        cancelText="Cancel"
      >
        <p>
          <center>Are you sure to log out?</center>
        </p>
      </Modal>
      {contextHolder}
    </>
  );
}

export default Header;
